import { useQuery } from '@tanstack/react-query';
import type { StorageApi, StorageFileListResponse } from '@/lib/api';
import { fetchAllStorageFiles } from '../utils';

/**
 * Fetches all files within a prefix for a storage arche (auto-paginates).
 * When enabled is false, the query is skipped (used for lazy loading on group expand).
 *
 * flat=true: no delimiter, returns all files recursively (for sub-groups)
 * flat=false: uses '/' delimiter, returns direct files + subfolder prefixes (for groups)
 */
export function useStorageFiles(
  api: StorageApi,
  queryKey: readonly string[],
  prefix: string,
  options?: { enabled?: boolean; flat?: boolean },
) {
  const enabled = options?.enabled ?? true;
  const flat = options?.flat ?? false;
  const delimiter = flat ? '' : '/';

  return useQuery<StorageFileListResponse>({
    queryKey: [...queryKey, flat ? 'flat' : 'nested'],
    queryFn: () => fetchAllStorageFiles(api, prefix, delimiter),
    enabled,
  });
}
